// Quiz data and logic
const quizData = [
    {
        id: 1,
        question: "How does your skin typically feel a few hours after cleansing (without applying any products)?",
        options: [
            { text: "Tight, dry, and sometimes flaky", tags: ["skin_type:dry"] },
            { text: "Oily and shiny, especially in the T-zone", tags: ["skin_type:oily"] },
            { text: "Oily in the T-zone but normal or dry on the cheeks", tags: ["skin_type:combination"] },
            { text: "Comfortable, neither too dry nor too oily", tags: ["skin_type:normal"] }
        ]
    },
    {
        id: 2,
        question: "How often do you experience breakouts (pimples, blackheads, whiteheads)?",
        options: [
            { text: "Rarely or never", tags: ["concern:none_acne"] },
            { text: "Occasionally, usually around my period or during stressful times", tags: ["concern:mild_acne"] },
            { text: "Frequently, with persistent pimples or clogged pores", tags: ["concern:acne"] },
            { text: "My skin is generally clear, but I get occasional hormonal breakouts", tags: ["concern:hormonal_acne"] }
        ]
    },
    {
        id: 3,
        question: "How does your skin react to new products or environmental changes?",
        options: [
            { text: "It often becomes red, itchy, or irritated", tags: ["skin_type:sensitive", "concern:redness"] },
            { text: "It adapts well, rarely showing adverse reactions", tags: ["skin_type:resilient"] },
            { text: "It might get a bit dry or oily, but nothing severe", tags: ["skin_type:normal"] },
            { text: "I'm prone to allergic reactions or rashes", tags: ["skin_type:very_sensitive"] }
        ]
    },
    {
        id: 4,
        question: "What is your biggest skincare concern right now?",
        options: [
            { text: "Dark spots, uneven skin tone, or hyperpigmentation", tags: ["concern:hyperpigmentation"] },
            { text: "Fine lines, wrinkles, or loss of firmness", tags: ["concern:finelines"] },
            { text: "Dryness, flakiness, or dullness", tags: ["concern:dryness"] },
            { text: "Breakouts, acne, or clogged pores", tags: ["concern:acne"] },
            { text: "Redness, irritation, or sensitivity", tags: ["concern:redness"] },
            { text: "Dark circles or puffiness under the eyes", tags: ["concern:darkcircles"] }
        ]
    },
    {
        id: 5,
        question: "Do you notice any changes in your skin related to hormonal shifts?",
        options: [
            { text: "Yes, significant changes like melasma, acne, or increased sensitivity", tags: ["concern:hormonal_changes"] },
            { text: "Some minor changes, but nothing too disruptive", tags: ["concern:mild_hormonal_changes"] },
            { text: "Not particularly", tags: ["concern:no_hormonal_impact"] }
        ]
    },
    {
        id: 6,
        question: "How much time can you realistically dedicate to your skincare routine each day?",
        options: [
            { text: "1-2 minutes, I need something super quick", tags: ["time:minimal", "lifestyle:busy"] },
            { text: "3-5 minutes, a simple routine is ideal", tags: ["time:short", "lifestyle:busy"] },
            { text: "5-10 minutes, I enjoy a few steps", tags: ["time:moderate", "lifestyle:balanced"] },
            { text: "10+ minutes, I love a comprehensive self-care ritual", tags: ["time:extensive", "lifestyle:dedicated"] }
        ]
    },
    {
        id: 7,
        question: "How often are you exposed to sun or environmental pollutants?",
        options: [
            { text: "Daily, I spend a lot of time outdoors or in urban environments", tags: ["exposure:high", "need:spf"] },
            { text: "Occasionally, some outdoor time or city exposure", tags: ["exposure:moderate", "need:spf"] },
            { text: "Rarely, mostly indoors", tags: ["exposure:low", "need:spf"] }
        ]
    },
    {
        id: 8,
        question: "How would you describe your stress levels on an average day?",
        options: [
            { text: "High, I'm constantly juggling many responsibilities", tags: ["stress:high", "concern:stress_skin"] },
            { text: "Moderate, I have busy periods but also downtime", tags: ["stress:moderate"] },
            { text: "Low, I generally feel calm and balanced", tags: ["stress:low"] }
        ]
    },
    {
        id: 9,
        question: "What kind of texture do you prefer for your skincare products?",
        options: [
            { text: "Lightweight gels or serums that absorb quickly", tags: ["texture:light"] },
            { text: "Rich creams or oils for deep hydration", tags: ["texture:rich"] },
            { text: "A mix of both, depending on the product", tags: ["texture:mix"] }
        ]
    },
    {
        id: 10,
        question: "What is most important to you when choosing skincare products?",
        options: [
            { text: "Natural, organic, or Ayurvedic ingredients", tags: ["preference:natural"] },
            { text: "Clinically proven results and dermatologist-recommended", tags: ["preference:scientific"] },
            { text: "Affordability and accessibility", tags: ["preference:value"] },
            { text: "Multi-tasking products that save time", tags: ["preference:multitask"] }
        ]
    }
];

// Quiz state
let currentQuestion = 0;
let answers = [];
let userTags = {};

// Initialize quiz
function startQuiz() {
    document.getElementById('welcomeScreen').classList.add('hidden');
    document.getElementById('quizContainer').classList.remove('hidden');
    showQuestion(0);
    updateProgress();
}

// Display current question
function showQuestion(questionIndex) {
    const question = quizData[questionIndex];
    const container = document.getElementById('questionContainer');
    
    container.innerHTML = `
        <div class="fade-in">
            <h3 class="text-xl font-semibold text-gray-800 mb-6">${question.question}</h3>
            <div class="space-y-3">
                ${question.options.map((option, index) => `
                    <div class="option-card bg-white border-2 border-gray-200 rounded-lg p-4 hover:border-purple-300" 
                         onclick="selectOption(${questionIndex}, ${index})" 
                         data-option="${index}">
                        <div class="flex items-center">
                            <div class="w-4 h-4 border-2 border-gray-300 rounded-full mr-3 option-radio"></div>
                            <span class="text-gray-700">${option.text}</span>
                        </div>
                    </div>
                `).join('')}
            </div>
        </div>
    `;
    
    // Restore previous selection if exists
    if (answers[questionIndex] !== undefined) {
        selectOption(questionIndex, answers[questionIndex], false);
    }
    
    updateNavigationButtons();
}

// Handle option selection
function selectOption(questionIndex, optionIndex, updateAnswers = true) {
    // Remove previous selection
    document.querySelectorAll('.option-card').forEach(card => {
        card.classList.remove('selected');
        card.querySelector('.option-radio').style.backgroundColor = '';
        card.querySelector('.option-radio').style.borderColor = '';
    });
    
    // Add selection to clicked option
    const selectedCard = document.querySelector(`[data-option="${optionIndex}"]`);
    selectedCard.classList.add('selected');
    selectedCard.querySelector('.option-radio').style.backgroundColor = 'white';
    selectedCard.querySelector('.option-radio').style.borderColor = 'white';
    
    if (updateAnswers) {
        answers[questionIndex] = optionIndex;
        
        // Update user tags
        const selectedOption = quizData[questionIndex].options[optionIndex];
        selectedOption.tags.forEach(tag => {
            userTags[tag] = (userTags[tag] || 0) + 1;
        });
    }
    
    updateNavigationButtons();
}

// Navigation functions
function nextQuestion() {
    if (currentQuestion < quizData.length - 1) {
        currentQuestion++;
        showQuestion(currentQuestion);
        updateProgress();
    } else {
        showResults();
    }
}

function previousQuestion() {
    if (currentQuestion > 0) {
        currentQuestion--;
        showQuestion(currentQuestion);
        updateProgress();
    }
}

// Update navigation buttons
function updateNavigationButtons() {
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    
    prevBtn.disabled = currentQuestion === 0;
    nextBtn.disabled = answers[currentQuestion] === undefined;
    
    if (currentQuestion === quizData.length - 1) {
        nextBtn.textContent = 'Get Results';
    } else {
        nextBtn.textContent = 'Next';
    }
}

// Update progress bar
function updateProgress() {
    const progress = ((currentQuestion + 1) / quizData.length) * 100;
    document.getElementById('progressBar').style.width = `${progress}%`;
    document.getElementById('progressText').textContent = `Question ${currentQuestion + 1} of ${quizData.length}`;
}

// Show results
function showResults() {
    document.getElementById('quizContainer').classList.add('hidden');
    document.getElementById('resultsScreen').classList.remove('hidden');
    
    // Update progress to 100%
    document.getElementById('progressBar').style.width = '100%';
    document.getElementById('progressText').textContent = 'Complete!';
    
    // Generate recommendations
    const recommendations = generateRecommendations();
    displayResults(recommendations);
}

// Generate personalized recommendations
function generateRecommendations() {
    // Analyze user tags to determine skin profile
    const skinType = getDominantTag('skin_type');
    const primaryConcern = getDominantTag('concern');
    const timeAvailable = getDominantTag('time');
    const preference = getDominantTag('preference');
    
    let recommendations = {
        skinProfile: getSkinProfileDescription(skinType, primaryConcern),
        routine: getRoutineRecommendation(timeAvailable, skinType, primaryConcern),
        products: getProductRecommendations(skinType, primaryConcern, preference),
        tips: getPersonalizedTips(skinType, primaryConcern, timeAvailable)
    };
    
    return recommendations;
}

// Helper function to get dominant tag in a category
function getDominantTag(category) {
    const categoryTags = Object.keys(userTags).filter(tag => tag.startsWith(category + ':'));
    if (categoryTags.length === 0) return null;
    
    return categoryTags.reduce((a, b) => userTags[a] > userTags[b] ? a : b);
}

// Get skin profile description
function getSkinProfileDescription(skinType, primaryConcern) {
    const skinTypeMap = {
        'skin_type:dry': 'Dry Skin',
        'skin_type:oily': 'Oily Skin',
        'skin_type:combination': 'Combination Skin',
        'skin_type:normal': 'Normal Skin',
        'skin_type:sensitive': 'Sensitive Skin',
        'skin_type:very_sensitive': 'Very Sensitive Skin'
    };
    
    const concernMap = {
        'concern:hyperpigmentation': 'with hyperpigmentation concerns',
        'concern:acne': 'with acne-prone tendencies',
        'concern:dryness': 'with dryness issues',
        'concern:finelines': 'with anti-aging focus',
        'concern:redness': 'with sensitivity and redness',
        'concern:darkcircles': 'with under-eye concerns'
    };
    
    const skinTypeDesc = skinTypeMap[skinType] || 'Normal Skin';
    const concernDesc = concernMap[primaryConcern] || '';
    
    return `${skinTypeDesc} ${concernDesc}`.trim();
}

// Get routine recommendation based on time availability
function getRoutineRecommendation(timeAvailable, skinType, primaryConcern) {
    const routines = {
        'time:minimal': {
            title: 'Quick & Essential (1-2 minutes)',
            morning: ['Gentle cleanser with Toner', 'SPF'],
            evening: ['Gentle Toner', 'Night moisturizer']
        },
        'time:short': {
            title: 'Simple & Effective (3-5 minutes)',
            morning: ['Gentle cleanser', 'Toner', 'Moisturizer', 'SPF 30+'],
            evening: ['Gentle cleanser', 'Treatment serum', 'Night moisturizer']
        },
        'time:moderate': {
            title: 'Balanced Routine (5-10 minutes)',
            morning: ['Gentle cleanser', 'Toner', 'Moisturizer', 'SPF 30+'],
            evening: ['Double cleanse', 'Toner', 'Treatment serum', 'Eye cream', 'Night moisturizer']
        },
        'time:extensive': {
            title: 'Complete Self-Care (10+ minutes)',
            morning: ['Gentle cleanser', 'Toner', 'Hyaluronic acid', 'Moisturizer', 'Eye cream', 'SPF 30+'],
            evening: ['Oil cleanser', 'Water-based cleanser', 'Exfoliant (2-3x/week)', 'Toner', 'Treatment serum', 'Face oil', 'Eye cream', 'Night moisturizer']
        }
    };
    
    return routines[timeAvailable] || routines['time:short'];
}

// Get product recommendations
function getProductRecommendations(skinType, primaryConcern, preference) {
    const products = {
        cleanser: getCleanserRecommendation(skinType),
        treatment: getTreatmentRecommendation(primaryConcern),
        moisturizer: getMoisturizerRecommendation(skinType),
        sunscreen: getSunscreenRecommendation(skinType)
    };
    
    return products;
}

function getCleanserRecommendation(skinType) {
    const cleansers = {
        'skin_type:dry': 'Cream or oil-based gentle cleanser ',
        'skin_type:oily': 'Foaming cleanser with salicylic acid',
        'skin_type:combination': 'Gentle gel cleanser',
        'skin_type:sensitive': 'Fragrance-free, gentle cleanser',
        'skin_type:normal': 'Gentle daily cleanser'
    };
    
    return cleansers[skinType] || cleansers['skin_type:normal'];
}

function getTreatmentRecommendation(primaryConcern) {
    const treatments = {
        'concern:hyperpigmentation': 'Rice Water or Niacinamide',
        'concern:acne': 'Salicylic acid or Benzoyl peroxide',
        'concern:dryness': 'Hyaluronic acid & Niacinamide serum',
        'concern:finelines': 'Ceramides or Rice Water serum',
        'concern:redness': 'Niacinamide, Aloe Vera, Soothing Toner',
        'concern:darkcircles': 'Caffeine pack, depigmentation serum'
    };
    
    return treatments[primaryConcern] || 'Rice Water, Apha arbutin serum for overall skin health';
}

function getMoisturizerRecommendation(skinType) {
    const moisturizers = {
        'skin_type:dry': 'Rich, hydrating moisturizer ',
        'skin_type:oily': 'Lightweight, oil-free moisturizer',
        'skin_type:combination': 'Balanced moisturizer',
        'skin_type:sensitive': 'Gentle, light on skin moisturizer',
        'skin_type:normal': 'Daily moisturizer'
    };
    
    return moisturizers[skinType] || moisturizers['skin_type:normal'];
}

function getSunscreenRecommendation(skinType) {
    const sunscreens = {
        'skin_type:sensitive': 'Dermat Tested sunscreen SPF 50',
        'skin_type:oily': 'Lightweight, non-comedogenic SPF 50',
        'skin_type:dry': 'Hydrating sunscreen SPF 50',
        'default': 'Broad-spectrum, Dermat Tested SPF 50'
    };
    
    return sunscreens[skinType] || sunscreens['default'];
}

// Get personalized tips
function getPersonalizedTips(skinType, primaryConcern, timeAvailable) {
    let tips = [
        "Always apply sunscreen, even on cloudy days - it's your best anti-aging investment!",
        "Be gentle with your skin - avoid harsh scrubbing or over-washing.",
        "Consistency is key - a simple routine done daily beats a complex one done sporadically."
    ];
    
    // Add specific tips based on profile
    if (timeAvailable === 'time:minimal') {
        tips.push("Try multi-tasking products like tinted moisturising SPF to save time.");
    }
    
    if (primaryConcern === 'concern:hyperpigmentation') {
        tips.push("Pigmentation serum in am and pm and gentle exfoliation 2-3 times per week can help fade dark spots.");
    }
    
    if (skinType === 'skin_type:sensitive') {
        tips.push("Introduce new products one at a time and patch test first to avoid reactions.");
    }
    
    return tips;
}

// Display results
function displayResults(recommendations) {
    const container = document.getElementById('resultsContent');
    
    container.innerHTML = `
        <div class="space-y-8">
            <!-- Skin Profile -->
            <div class="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-6">
                <h3 class="text-xl font-semibold text-gray-800 mb-3">Your Skin Profile</h3>
                <p class="text-gray-700 text-lg">${recommendations.skinProfile}</p>
            </div>
            
            <!-- Recommended Routine -->
            <div class="bg-white rounded-lg p-6 border border-gray-200">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">${recommendations.routine.title}</h3>
                <div class="grid md:grid-cols-2 gap-6">
                    <div>
                        <h4 class="font-medium text-gray-800 mb-3 flex items-center">
                            <span class="w-3 h-3 bg-yellow-400 rounded-full mr-2"></span>
                            Morning Routine
                        </h4>
                        <ul class="space-y-2">
                            ${recommendations.routine.morning.map(step => `
                                <li class="text-gray-600 flex items-start">
                                    <span class="w-2 h-2 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                    ${step}
                                </li>
                            `).join('')}
                        </ul>
                    </div>
                    <div>
                        <h4 class="font-medium text-gray-800 mb-3 flex items-center">
                            <span class="w-3 h-3 bg-purple-400 rounded-full mr-2"></span>
                            Evening Routine
                        </h4>
                        <ul class="space-y-2">
                            ${recommendations.routine.evening.map(step => `
                                <li class="text-gray-600 flex items-start">
                                    <span class="w-2 h-2 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                    ${step}
                                </li>
                            `).join('')}
                        </ul>
                    </div>
                </div>
            </div>
            
            <!-- Product Recommendations -->
            <div class="bg-white rounded-lg p-6 border border-gray-200">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Recommended Products</h3>
                <div class="grid md:grid-cols-2 gap-4">
                    <div class="space-y-3">
                        <div class="p-3 bg-gray-50 rounded-lg">
                            <h5 class="font-medium text-gray-800">Cleanser</h5>
                            <p class="text-sm text-gray-600">${recommendations.products.cleanser}</p>
                        </div>
                        <div class="p-3 bg-gray-50 rounded-lg">
                            <h5 class="font-medium text-gray-800">Treatment</h5>
                            <p class="text-sm text-gray-600">${recommendations.products.treatment}</p>
                        </div>
                    </div>
                    <div class="space-y-3">
                        <div class="p-3 bg-gray-50 rounded-lg">
                            <h5 class="font-medium text-gray-800">Moisturizer</h5>
                            <p class="text-sm text-gray-600">${recommendations.products.moisturizer}</p>
                        </div>
                        <div class="p-3 bg-gray-50 rounded-lg">
                            <h5 class="font-medium text-gray-800">Sunscreen</h5>
                            <p class="text-sm text-gray-600">${recommendations.products.sunscreen}</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Personalized Tips -->
            <div class="bg-gradient-to-r from-green-50 to-blue-50 rounded-lg p-6">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Your Personalized Tips</h3>
                <ul class="space-y-3">
                    ${recommendations.tips.map(tip => `
                        <li class="text-gray-700 flex items-start">
                            <span class="w-2 h-2 bg-green-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                            ${tip}
                        </li>
                    `).join('')}
                </ul>
            </div>
            
            <!-- Call to Action -->
            <div class="bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg p-6 text-white text-center">
                <h3 class="text-xl font-semibold mb-3">Ready to Start Your Journey?</h3>
                <p class="mb-4">Remember, consistency is more important than perfection. Start with one or two products and gradually build your routine.</p>
                <p class="text-sm opacity-90">💡 Pro tip: Take a screenshot of your results for easy reference while shopping!</p>
            </div>
        </div>
    `;
}

// Restart quiz
function restartQuiz() {
    currentQuestion = 0;
    answers = [];
    userTags = {};
    
    document.getElementById('resultsScreen').classList.add('hidden');
    document.getElementById('welcomeScreen').classList.remove('hidden');
    
    // Reset progress
    document.getElementById('progressBar').style.width = '0%';
    document.getElementById('progressText').textContent = 'Question 1 of 10';
}

// Initialize the quiz when page loads
document.addEventListener('DOMContentLoaded', function() {
    // Quiz is ready to start
    console.log('Skincare Quiz for Moms loaded successfully!');
});

